const IconExit = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.999 4.50024V11.6252"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5002 5.08437C17.9907 6.05447 19.1279 7.48026 19.7422 9.14925C20.3565 10.8182 20.415 12.641 19.9091 14.346C19.4031 16.051 18.3598 17.5468 16.9345 18.6105C15.5093 19.6742 13.7784 20.2489 12 20.2489C10.2215 20.2489 8.4907 19.6742 7.06545 18.6105C5.64021 17.5467 4.59685 16.0509 4.0909 14.346C3.58495 12.641 3.64349 10.8182 4.2578 9.14921C4.8721 7.48023 6.00929 6.05444 7.49985 5.08435"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="ml-2"
    viewBox="0 0 16 16"
  >
    <path d="M1.5 5.5l6 6 6-6" />
  </svg>
);

const IconPencil = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="#004c50"
    height={14}
    width={14}
    className="inline"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.862 3.487a2.25 2.25 0 013.182 3.182L8.25 18.465a4.5 4.5 0 01-1.591 1.034l-4.305 1.613c-.637.238-1.254-.38-1.016-1.016l1.613-4.305a4.5 4.5 0 011.034-1.591L16.862 3.487zM19.5 7.5L16.5 4.5M4.5 19.5l3-3"
    />
  </svg>
);

const IconSentiment = (
  <svg
    className="w-6"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="14"
    height="14"
    fill="currentColor"
    x="0"
    y="0"
    viewBox="0 0 48 48"
  >
    <g>
      <path
        d="M.58 25.67c-.05.13-.08.26-.08.39 0 4.86 3.96 8.82 8.82 8.82s8.82-3.95 8.82-8.82c0-.13-.03-.26-.08-.38v-.01L10.49 7.46l10.04 1.43v2.95H23v26.07a8.668 8.668 0 0 0-7.59 7.59H.5v2h47v-2H32.59A8.668 8.668 0 0 0 25 37.91V11.83h2.46V9.87l10.23 1.45-7.75 18.67V30c-.05.12-.08.25-.08.38 0 4.86 3.95 8.82 8.82 8.82s8.82-3.96 8.82-8.82c0-.13-.03-.26-.08-.38v-.01l-7.63-18.37 7.56 1.07.28-1.98-20.17-2.86V4.9H25V.5h-2v4.4h-2.46v1.96L.65 4.04.37 6.02l7.9 1.12zM9.32 9.84l6.32 15.22H3zm0 23.04c-3.42 0-6.25-2.53-6.74-5.82h13.47c-.48 3.29-3.32 5.82-6.73 5.82zM30.57 45.5H17.43c.48-3.2 3.24-5.66 6.57-5.66s6.09 2.46 6.57 5.66zm8.11-31.34L45 29.38H32.37zm0 23.04c-3.42 0-6.25-2.53-6.74-5.82h13.47a6.8 6.8 0 0 1-6.73 5.82zM22.54 6.9h2.93v2.93h-2.93z"
        stroke="currentColor"
        strokeWidth="2"
        opacity="1"
        dataoriginal="#000000"
      ></path>
    </g>
  </svg>
);

const IconHandDollar = (
  <svg
    className="w-6"
    width="14"
    height="14"
    viewBox="0 0 512 512"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_2)">
      <path
        d="M152.391 226.561C151.861 226.443 151.314 226.424 150.778 226.505C145.388 225.864 141.322 221.204 141.313 215.661C141.313 214.385 140.817 213.162 139.934 212.26C139.051 211.358 137.854 210.851 136.606 210.851C135.357 210.851 134.16 211.358 133.277 212.26C132.394 213.162 131.898 214.385 131.898 215.661C131.913 224.917 137.971 233.025 146.705 235.474V240.284C146.705 241.56 147.201 242.784 148.084 243.686C148.966 244.588 150.164 245.095 151.412 245.095C152.66 245.095 153.858 244.588 154.74 243.686C155.623 242.784 156.119 241.56 156.119 240.284V235.765C166.2 233.609 173.051 224.015 171.992 213.547C170.93 203.079 162.3 195.124 152 195.122C146.098 195.122 141.313 190.232 141.313 184.201C141.313 178.169 146.098 173.279 152 173.279C157.903 173.279 162.688 178.169 162.688 184.201C162.688 185.476 163.184 186.7 164.067 187.602C164.949 188.504 166.147 189.011 167.395 189.011C168.644 189.011 169.841 188.504 170.724 187.602C171.606 186.7 172.102 185.476 172.102 184.201C172.089 174.482 165.426 166.099 156.119 164.093V159.716C156.119 158.44 155.623 157.216 154.74 156.314C153.858 155.412 152.66 154.906 151.412 154.906C150.164 154.906 148.966 155.412 148.084 156.314C147.201 157.216 146.705 158.44 146.705 159.716V164.387C136.992 167.097 130.74 176.734 132.077 186.932C133.415 197.13 141.931 204.742 152 204.74C157.825 204.74 162.576 209.505 162.681 215.454C162.789 221.404 158.211 226.345 152.391 226.561Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M83 200C83 238.108 113.892 269 152 269C190.108 269 221 238.108 221 200C221 161.892 190.108 131 152 131C113.91 131.042 83.0446 161.91 83 200ZM152 140.517C184.852 140.517 211.483 167.148 211.483 200C211.483 232.852 184.852 259.483 152 259.483C119.148 259.483 92.5166 232.852 92.5166 200C92.5541 167.164 119.164 140.554 152 140.517Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M317.883 304.484C317.364 304.368 316.829 304.349 316.304 304.429C311.032 303.802 307.054 299.243 307.045 293.821C307.045 292.573 306.56 291.376 305.696 290.493C304.833 289.611 303.662 289.115 302.44 289.115C301.219 289.115 300.048 289.611 299.184 290.493C298.321 291.376 297.835 292.573 297.835 293.821C297.849 302.875 303.776 310.807 312.32 313.203V317.909C312.32 319.157 312.805 320.354 313.669 321.236C314.532 322.118 315.704 322.614 316.925 322.614C318.146 322.614 319.317 322.118 320.181 321.236C321.044 320.354 321.53 319.157 321.53 317.909V313.488C331.391 311.379 338.094 301.993 337.058 291.752C336.019 281.512 327.576 273.73 317.5 273.728C311.727 273.728 307.045 268.944 307.045 263.044C307.045 257.144 311.727 252.36 317.5 252.36C323.274 252.36 327.956 257.143 327.956 263.044C327.956 264.292 328.441 265.489 329.304 266.371C330.168 267.254 331.339 267.75 332.561 267.75C333.782 267.75 334.953 267.254 335.817 266.371C336.68 265.489 337.165 264.292 337.165 263.044C337.152 253.537 330.634 245.336 321.53 243.374V239.091C321.53 237.843 321.044 236.646 320.181 235.764C319.317 234.882 318.146 234.386 316.925 234.386C315.704 234.386 314.532 234.882 313.669 235.764C312.805 236.646 312.32 237.843 312.32 239.091V243.662C302.818 246.313 296.702 255.74 298.01 265.716C299.319 275.693 307.65 283.138 317.5 283.137C323.198 283.137 327.846 287.799 327.949 293.618C328.055 299.438 323.576 304.272 317.883 304.484Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M250 278.5C250 315.78 280.22 346 317.5 346C354.78 346 385 315.78 385 278.5C385 241.22 354.78 211 317.5 211C280.238 211.041 250.044 241.238 250 278.5ZM317.5 220.31C349.638 220.31 375.69 246.362 375.69 278.5C375.69 310.638 349.638 336.69 317.5 336.69C285.362 336.69 259.31 310.638 259.31 278.5C259.346 246.377 285.377 220.346 317.5 220.31Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M394.727 376.064L328.939 407.149C324.476 398.848 317.903 391.871 309.883 386.921C301.862 381.972 292.678 379.226 283.258 378.96L222.526 377.291C212.907 377.015 203.473 374.58 194.924 370.164L188.744 366.962C173.154 358.836 155.83 354.602 138.249 354.62C120.669 354.639 103.353 358.909 87.7804 367.068L88.1656 353.068C88.1962 351.965 88.0093 350.867 87.6156 349.837C87.2219 348.807 86.629 347.864 85.8708 347.063C85.1127 346.261 84.2041 345.617 83.1971 345.167C82.19 344.717 81.1041 344.47 80.0015 344.44L13.4052 342.608C12.3027 342.577 11.205 342.764 10.1749 343.158C9.14473 343.552 8.20228 344.145 7.4014 344.904C6.60052 345.662 5.9569 346.57 5.50732 347.578C5.05774 348.585 4.81101 349.67 4.78123 350.773L0.758451 496.912C0.727699 498.015 0.914535 499.113 1.30828 500.144C1.70203 501.175 2.29498 502.117 3.05324 502.919C3.81151 503.72 4.72024 504.364 5.72751 504.814C6.73478 505.264 7.82085 505.512 8.92368 505.542L75.5189 507.375H75.7488C77.9371 507.375 80.0392 506.522 81.6078 504.996C83.1764 503.47 84.0874 501.393 84.1471 499.205L84.3392 492.214L101.64 482.95C108.428 479.296 116.371 478.427 123.789 480.526L227.103 509.522C227.283 509.576 227.463 509.617 227.648 509.659C235.116 511.22 242.724 512.005 250.353 512C266.51 512.01 282.479 508.525 297.163 501.786C297.524 501.621 297.873 501.428 298.204 501.21L448 404.319C449.798 403.156 451.084 401.35 451.595 399.271C452.106 397.192 451.804 394.996 450.751 393.132C439.631 373.399 414.964 365.883 394.727 376.064ZM17.7807 488.982L21.3395 359.629L71.1434 360.999L67.5846 490.357L17.7807 488.982ZM289.597 486.784C271.353 495.017 250.978 497.292 231.367 493.284L128.333 464.362C116.739 461.085 104.326 462.442 93.7138 468.146L84.8725 472.883L87.2387 386.878C100.993 377.73 116.951 372.44 133.447 371.56C149.943 370.68 166.372 374.243 181.022 381.876L187.202 385.078C198.002 390.654 209.917 393.732 222.066 394.084L282.802 395.753C299.861 396.244 314.349 408.39 317.81 425.105L227.344 422.608C222.706 422.482 218.847 426.139 218.716 430.773C218.655 433 219.481 435.16 221.012 436.778C222.543 438.396 224.654 439.339 226.881 439.401L326.717 442.148H326.951C329.138 442.147 331.238 441.293 332.804 439.767C334.371 438.241 335.281 436.165 335.341 433.979C335.444 430.329 335.172 426.678 334.529 423.084L402.006 391.2C402.072 391.172 402.137 391.139 402.204 391.106C406.877 388.741 412.162 387.863 417.349 388.59C422.536 389.316 427.376 391.613 431.22 395.17L289.597 486.784ZM259.941 165.182V8.39828C259.941 6.17092 259.057 4.03478 257.482 2.4598C255.907 0.884816 253.771 0 251.543 0C249.316 0 247.18 0.884816 245.605 2.4598C244.03 4.03478 243.145 6.17092 243.145 8.39828V165.182C243.145 167.409 244.03 169.545 245.605 171.12C247.18 172.695 249.316 173.58 251.543 173.58C253.771 173.58 255.907 172.695 257.482 171.12C259.057 169.545 259.941 167.409 259.941 165.182ZM302.929 113.182V50.3897C302.929 48.1623 302.044 46.0262 300.469 44.4512C298.894 42.8762 296.758 41.9914 294.53 41.9914C292.303 41.9914 290.167 42.8762 288.592 44.4512C287.017 46.0262 286.132 48.1623 286.132 50.3897V113.182C286.132 115.409 287.017 117.545 288.592 119.12C290.167 120.695 292.303 121.58 294.53 121.58C296.758 121.58 298.894 120.695 300.469 119.12C302.044 117.545 302.929 115.409 302.929 113.182ZM176.954 88.1819V50.3897C176.954 48.1623 176.07 46.0262 174.495 44.4512C172.92 42.8762 170.783 41.9914 168.556 41.9914C166.329 41.9914 164.193 42.8762 162.618 44.4512C161.043 46.0262 160.158 48.1623 160.158 50.3897V88.1819C160.158 90.4093 161.043 92.5454 162.618 94.1204C164.193 95.6954 166.329 96.5802 168.556 96.5802C170.783 96.5802 172.92 95.6954 174.495 94.1204C176.07 92.5454 176.954 90.4093 176.954 88.1819Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M220.797 42.3983V122.182C220.797 124.409 219.912 126.545 218.337 128.12C216.762 129.695 214.626 130.58 212.398 130.58C210.171 130.58 208.035 129.695 206.46 128.12C204.885 126.545 204 124.409 204 122.182V42.3983C204 40.1709 204.885 38.0348 206.46 36.4598C208.035 34.8848 210.171 34 212.398 34C214.626 34 216.762 34.8848 218.337 36.4598C219.912 38.0348 220.797 40.1709 220.797 42.3983Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M336.797 141.191V103.398C336.797 101.171 335.912 99.0348 334.337 97.4598C332.762 95.8848 330.626 95 328.398 95C326.171 95 324.035 95.8848 322.46 97.4598C320.885 99.0348 320 101.171 320 103.398V141.191C320 143.418 320.885 145.554 322.46 147.129C324.035 148.704 326.171 149.589 328.398 149.589C330.626 149.589 332.762 148.704 334.337 147.129C335.912 145.554 336.797 143.418 336.797 141.191Z"
        // fill="#64748B"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const TrendingStore = (
<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512"><path d="M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"/></svg>
);

const IconEyeOpen = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="16"
    height="16"
    x="0"
    y="0"
    viewBox="0 0 511.999 511.999"
  >
    <g>
      <path
        d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 0 0 0 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 0 0 0-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z"
        fill="#000000"
        opacity="1"
        dataOriginal="#000000"
      ></path>
      <path
        d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z"
        fill="#000000"
        opacity="1"
        dataOriginal="#000000"
      ></path>
    </g>
  </svg>
);

const IconEyeClose = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="16"
    height="16"
    x="0"
    y="0"
    viewBox="0 0 128 128"
  >
    <g>
      <path
        d="m79.891 65.078 7.27-7.27C87.69 59.787 88 61.856 88 64c0 13.234-10.766 24-24 24-2.144 0-4.213-.31-6.192-.839l7.27-7.27a15.929 15.929 0 0 0 14.813-14.813zm47.605-3.021c-.492-.885-7.47-13.112-21.11-23.474l-5.821 5.821c9.946 7.313 16.248 15.842 18.729 19.602C114.553 71.225 95.955 96 64 96c-4.792 0-9.248-.613-13.441-1.591l-6.573 6.573C50.029 102.835 56.671 104 64 104c41.873 0 62.633-36.504 63.496-38.057a3.997 3.997 0 0 0 0-3.886zm-16.668-39.229-88 88C22.047 111.609 21.023 112 20 112s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656l11.196-11.196C10.268 83.049 1.071 66.964.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24c10.827 0 20.205 2.47 28.222 6.122l12.95-12.95c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656zM34.333 88.011 44.46 77.884C41.663 73.96 40 69.175 40 64c0-13.234 10.766-24 24-24 5.175 0 9.96 1.663 13.884 4.459l8.189-8.189C79.603 33.679 72.251 32 64 32 32.045 32 13.447 56.775 8.707 63.994c3.01 4.562 11.662 16.11 25.626 24.017zm15.934-15.935 21.809-21.809C69.697 48.862 66.958 48 64 48c-8.822 0-16 7.178-16 16 0 2.958.862 5.697 2.267 8.076z"
        fill="#000000"
        opacity="1"
        dataOriginal="#000000"
      ></path>
    </g>
  </svg>
);

const HeartIcon = (
  <svg
    width="26"
    height="23"
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6466 2.98342C22.0868 2.42286 21.422 1.97819 20.6904 1.67481C19.9587 1.37142 19.1745 1.21527 18.3825 1.21527C17.5905 1.21527 16.8063 1.37142 16.0747 1.67481C15.343 1.97819 14.6783 2.42286 14.1184 2.98342L12.9565 4.14622L11.7945 2.98342C10.6636 1.85167 9.12974 1.21586 7.53038 1.21586C5.93103 1.21586 4.39717 1.85167 3.26626 2.98342C2.13534 4.11516 1.5 5.65014 1.5 7.25068C1.5 8.85121 2.13534 10.3862 3.26626 11.5179L4.4282 12.6807L12.9565 21.2153L21.4847 12.6807L22.6466 11.5179C23.2068 10.9577 23.6511 10.2924 23.9543 9.56022C24.2575 8.82803 24.4135 8.04324 24.4135 7.25068C24.4135 6.45812 24.2575 5.67333 23.9543 4.94114C23.6511 4.20895 23.2068 3.54371 22.6466 2.98342Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HeartFilledIcon = (
  <svg
    width="26"
    height="23"
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6466 3.5876C22.0868 3.02705 21.422 2.58238 20.6904 2.27899C19.9587 1.97561 19.1745 1.81946 18.3825 1.81946C17.5905 1.81946 16.8063 1.97561 16.0747 2.27899C15.343 2.58238 14.6783 3.02705 14.1184 3.5876L12.9565 4.7504L11.7945 3.5876C10.6636 2.45585 9.12974 1.82004 7.53038 1.82004C5.93103 1.82004 4.39717 2.45585 3.26626 3.5876C2.13534 4.71935 1.5 6.25433 1.5 7.85487C1.5 9.4554 2.13534 10.9904 3.26626 12.1221L4.4282 13.2849L12.9565 21.8195L21.4847 13.2849L22.6466 12.1221C23.2068 11.5618 23.6511 10.8966 23.9543 10.1644C24.2575 9.43221 24.4135 8.64742 24.4135 7.85487C24.4135 7.06231 24.2575 6.27752 23.9543 5.54533C23.6511 4.81314 23.2068 4.14789 22.6466 3.5876Z"
      fill="#004C50"
      stroke="#004C50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CommentIcon = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.39733 10.6597C1.39351 12.1263 1.73589 13.5729 2.39659 14.8819C3.17998 16.4506 4.38429 17.7699 5.87464 18.6923C7.36498 19.6146 9.0825 20.1035 10.8348 20.1042C12.3002 20.108 13.7459 19.7654 15.0539 19.1042L21.3826 21.2153L19.273 14.8819C19.9337 13.5729 20.2761 12.1263 20.2723 10.6597C20.2716 8.90613 19.7831 7.18735 18.8614 5.69591C17.9398 4.20446 16.6214 2.99926 15.0539 2.2153C13.7459 1.55411 12.3002 1.21148 10.8348 1.2153H10.2797C7.96543 1.34307 5.7796 2.32059 4.14071 3.9607C2.50181 5.6008 1.525 7.78824 1.39733 10.1042V10.6597Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShareIcon = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3664 14.5486V18.9931C21.3664 19.5825 21.1323 20.1477 20.7155 20.5644C20.2988 20.9812 19.7336 21.2153 19.1442 21.2153H3.58862C2.99925 21.2153 2.43402 20.9812 2.01728 20.5644C1.60053 20.1477 1.3664 19.5825 1.3664 18.9931V14.5486"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.922 6.77083L11.3664 1.21527L5.81085 6.77083"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3664 1.21527V14.5486"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SmallShareIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3664 14.5486V18.9931C21.3664 19.5825 21.1323 20.1477 20.7155 20.5644C20.2988 20.9812 19.7336 21.2153 19.1442 21.2153H3.58862C2.99925 21.2153 2.43402 20.9812 2.01728 20.5644C1.60053 20.1477 1.3664 19.5825 1.3664 18.9931V14.5486"
      stroke="#888888"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.922 6.77083L11.3664 1.21527L5.81085 6.77083"
      stroke="#888888"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3664 1.21527V14.5486"
      stroke="#888888"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RepostIcon = (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0534 1.21527L17.6871 4.85163L14.0534 8.488"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33549 10.3062V8.48799C1.33549 7.52356 1.71833 6.59864 2.39978 5.91669C3.08123 5.23474 4.00547 4.85162 4.96918 4.85162H17.6871"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.96918 21.2153L1.33549 17.5789L4.96918 13.9426"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6871 12.1243V13.9425C17.6871 14.9069 17.3043 15.8319 16.6228 16.5138C15.9414 17.1958 15.0171 17.5789 14.0534 17.5789H1.33549"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TheDotsIcon = (
  <svg
    width="18"
    height="4"
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.77166 2.76715C9.32313 2.76715 9.77019 2.31944 9.77019 1.76715C9.77019 1.21487 9.32313 0.767151 8.77166 0.767151C8.22019 0.767151 7.77313 1.21487 7.77313 1.76715C7.77313 2.31944 8.22019 2.76715 8.77166 2.76715Z"
      stroke="#111111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7613 2.76715C16.3128 2.76715 16.7599 2.31944 16.7599 1.76715C16.7599 1.21487 16.3128 0.767151 15.7613 0.767151C15.2099 0.767151 14.7628 1.21487 14.7628 1.76715C14.7628 2.31944 15.2099 2.76715 15.7613 2.76715Z"
      stroke="#111111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.78195 2.76715C2.33342 2.76715 2.78048 2.31944 2.78048 1.76715C2.78048 1.21487 2.33342 0.767151 1.78195 0.767151C1.23047 0.767151 0.783417 1.21487 0.783417 1.76715C0.783417 2.31944 1.23047 2.76715 1.78195 2.76715Z"
      stroke="#111111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SaveIcon = (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 21.2153L9.72793 15.6597L1.95587 21.2153V3.43749C1.95587 2.84812 2.18983 2.28289 2.60627 1.86614C3.02271 1.4494 3.58752 1.21527 4.17646 1.21527H15.2794C15.8683 1.21527 16.4331 1.4494 16.8496 1.86614C17.266 2.28289 17.5 2.84812 17.5 3.43749V21.2153Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SaveIconFill = (
  <svg
    width="19"
    height="23"
    viewBox="0 0 19 23"
    fill="#004C50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 21.2153L9.72793 15.6597L1.95587 21.2153V3.43749C1.95587 2.84812 2.18983 2.28289 2.60627 1.86614C3.02271 1.4494 3.58752 1.21527 4.17646 1.21527H15.2794C15.8683 1.21527 16.4331 1.4494 16.8496 1.86614C17.266 2.28289 17.5 2.84812 17.5 3.43749V21.2153Z"
      stroke="#004C50"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export {
  SaveIconFill,
  SaveIcon,
  IconExit,
  IconArrow,
  IconPencil,
  IconHandDollar,
  IconSentiment,
  IconEyeClose,
  IconEyeOpen,
  HeartFilledIcon,
  HeartIcon,
  ShareIcon,
  SmallShareIcon,
  RepostIcon,
  CommentIcon,
  TheDotsIcon,
  TrendingStore
};
